import React from 'react';
import { RouteObject, Navigate, useSearchParams } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import AuthCallback from '../pages/AuthCallback';
import PublicBandListPage from '../pages/PublicBandListPage';
import PublicStrandsPage from '../pages/PublicStrandsPage';
import PublicLayout from '../components/layout/PublicLayout';
import PublishedBandListPage from '../pages/PublishedBandListPage';
import BandRecommendationPage from '../pages/BandRecommendationPage';
import BanBamPage from '../pages/BanBamPage';
import FormPage from '../pages/FormPage';
import BanBam2025Announcement from '../pages/BanBam2025Announcement';
import SingleTitoEventPage from '../pages/SingleTitoEventPage';
import MusicAdminPage from '../pages/Artists/MusicAdminPage';
import ArtistSignupPage from '../pages/Artists/ArtistSignupPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import InvestorDashboard from '../pages/InvestorDashboard';
import MusicianPage from '../pages/MusicianPage';
import QRRedirectPage from '../pages/QRRedirectPage';
import JuryLoginPage from '../pages/jury/LoginPage';
import JuryApplicationsPage from '../pages/jury/ApplicationsPage';
import ApplicationDetailPage from '../pages/jury/ApplicationDetailPage';
import GuidelineViewPage from '../pages/GuidelineViewPage';
import SubmissionSuccess from '../pages/SubmissionSuccess';
import PublicPortfolio from '../pages/PublicPortfolio';
import DynamicFormPage from '../pages/DynamicFormPage';
import FormSubmissionSuccess from '../pages/FormSubmissionSuccess';
import { BandViewProvider } from '../contexts/BandViewContext';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types/User';
import BandDetailPage from '../pages/BandDetailPage';

const BandDetailPageWithProvider = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();

  const typedUser = user ? {
    ...user,
    role: user.role as UserRole,
    createdAt: new Date(),
    updatedAt: new Date()
  } : null;

  const getInitialViewMode = (): 'admin' | 'artist' | 'strand' | 'judge' | 'public' => {
    if (window.location.pathname.includes('/strands/')) return 'strand';
    if (!user) return 'public';
    const viewParam = searchParams.get('view');
    if (viewParam === 'strand' && (user.role === 'admin' || user.role === 'gm')) return 'strand';
    if (viewParam === 'judge' && (user.role === 'admin' || user.role === 'gm' || user.role === 'judge')) return 'judge';
    if (viewParam === 'artist' && (user.role === 'admin' || user.role === 'gm' || user.role === 'artist')) return 'artist';
    if (user.role === 'admin' || user.role === 'gm') return 'admin';
    if (user.role === 'artist') return 'artist';
    return 'public';
  };

  return (
    <BandViewProvider currentUser={typedUser} initialViewMode={getInitialViewMode()}>
      <BandDetailPage />
    </BandViewProvider>
  );
};


export const publicRoutes: RouteObject[] = [
    {
      element: <PublicLayout />,
      children: [
  { path: '/', element: <Navigate to="/bands" replace /> },
  { path: '/bands', element: <PublicBandListPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/auth-callback', element: <AuthCallback /> },
  { path: '/publicstrands', element: <PublicStrandsPage /> },
  { path: '/form/:slug', element: <DynamicFormPage /> },
  { path: '/strands/:strandSlug', element: <PublishedBandListPage /> },
  { path: '/strands/:strandSlug/band/:bandId', element: <BandDetailPageWithProvider /> },
  { path: '/submit', element: <BandRecommendationPage /> },
  { path: '/banbam', element: <BanBamPage /> },
  { path: '/band/:id', element: <BandDetailPageWithProvider /> },
  { path: '/navigator', element: <FormPage /> },
  { path: '/banbamfaq', element: <BanBam2025Announcement /> },
  { path: '/event/:slug', element: <SingleTitoEventPage /> },
  { path: "/musicadmin", element: <MusicAdminPage />},
  { path: '/artist/signup', element: <ArtistSignupPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/investor/dashboard', element: <InvestorDashboard /> },
  { path: '/form-submission-success/:slug', element: <FormSubmissionSuccess /> },
  { path: '/jury/login', element: <JuryLoginPage /> },
  { path: '/jury/applications', element: <JuryApplicationsPage /> },
  {
    path: '/jury/applications/:id',
    element: <ApplicationDetailPage />
  },
  { path: '/guidelines/strand/:strandSlug', element: <GuidelineViewPage /> },
  { path: '/submission-success', element: <SubmissionSuccess /> },
  { path: '/portfolio/:slug', element: <PublicPortfolio /> },
  { path: '/musician/:name', element: <MusicianPage /> },
  { path: '/go/band/:bandId', element: <QRRedirectPage /> },
],
},
];
export default publicRoutes;
